import React, { useState } from 'react';
import { Monitor, Package, ShieldCheck } from 'lucide-react';
import { serviceTabs } from '../mock';

const iconMap = { Monitor, Package, ShieldCheck };
const tabKeys = ['computer', 'software', 'antivirus'];

const Services = () => {
  const [active, setActive] = useState('computer');
  const current = serviceTabs[active];

  return (
    <section id="support" className="py-20 md:py-24 bg-gradient-to-b from-slate-50 to-white">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="text-center max-w-2xl mx-auto">
          <h2 className="font-heading font-bold text-slate-900 text-3xl md:text-4xl">Our Support Services</h2>
          <p className="mt-4 text-slate-500 text-lg">Comprehensive technical support for all your computer needs</p>
        </div>

        {/* Tabs */}
        <div className="mt-12 max-w-3xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-2 bg-slate-100 p-1.5 rounded-xl">
            {tabKeys.map((key) => {
              const Icon = iconMap[serviceTabs[key].icon];
              const isActive = active === key;
              return (
                <button
                  key={key}
                  onClick={() => setActive(key)}
                  className={`flex items-center justify-center gap-2 py-3 px-4 rounded-lg text-sm font-medium transition-all ${
                    isActive ? 'bg-white text-blue-600 shadow-sm' : 'text-slate-600 hover:text-slate-900'
                  }`}
                >
                  <Icon size={18} />
                  {serviceTabs[key].label}
                </button>
              );
            })}
          </div>
        </div>

        {/* Cards */}
        <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {current.items.map((item, i) => (
            <div
              key={item.name}
              className="group bg-white border border-slate-100 rounded-xl p-6 shadow-sm hover:shadow-lg hover:border-blue-200 hover:-translate-y-1 transition-all duration-300 animate-fade-up"
              style={{ animationDelay: `${i * 0.04}s` }}
            >
              <h3 className="font-heading font-semibold text-slate-900 text-lg group-hover:text-blue-600 transition-colors">{item.name}</h3>
              <div className="mt-2 h-0.5 w-8 bg-blue-500 rounded-full group-hover:w-14 transition-all" />
              <p className="mt-4 text-slate-500 text-sm leading-relaxed">{item.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
